import { all, fork } from "redux-saga/effects";

//auth
import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import organisationSaga from "./organisation/sagas";
import itemsSaga from "./items/sagas";
import partiesSaga from "./parties/sagas";
import purchaseOrdersSaga from "./purchase-orders/sagas";
import reportsSaga from "./reports/sagas";
import notificationSaga from "./Notification/sagas"
export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(layoutSaga),
    fork(organisationSaga),
    fork(reportsSaga),
    fork(itemsSaga),
    fork(purchaseOrdersSaga),
    fork(partiesSaga),
    fork(notificationSaga)
  ]);
}
